import { defineComponent } from 'vue';
import { getPrefixCls } from '../_utils/global-config';

export default defineComponent({
  name: 'Diff',
  props: {
    direction: {
      type: String,
      default: 'row',
    },
  },
  setup(props, { slots }) {
    const prefixCls = getPrefixCls('diff');
    return () => {
      const children = slots.default?.();
      const content = slots.content?.();
      const direction = props?.direction || 'row';
      return (
        <div class={`${prefixCls} ${direction}`}>
          {content && direction === 'column' && (
            <div class={`${prefixCls}-notice`}>
              <div class={`${prefixCls}-notice-content column`}>{content}</div>
            </div>
          )}
          <div class={`${prefixCls}-children ${direction}`}>{children}</div>
          {content && direction === 'row' && (
            <div class={`${prefixCls}-notice`}>
              <div class={`${prefixCls}-notice-content`}>{content}</div>
            </div>
          )}
        </div>
      );
    };
  },
});
